/** ServiceTicketsRoute — skin-aware switcher for /service-tickets. */
import { useUISkin } from "@/data/UISkinContext";
import ServiceTicketsPage from "./ServiceTicketsPage";
import { CockpitFrame } from "@/components/cockpit/CockpitFrame";

export default function ServiceTicketsRoute() {
  const { skin } = useUISkin();
  if (skin === "cockpit") {
    return (
      <CockpitFrame eyebrow="Operations · Service" title="Service Tickets">
        <ServiceTicketsPage />
      </CockpitFrame>
    );
  }
  return <ServiceTicketsPage />;
}
